import { Record, Map, List } from 'immutable'
import * as channelTypes from 'remote/channels/types'

const ChannelsPermissions = Record({
  read: false,
  write: false,
  manage: false,
  collaborate: false,
  organize: false,
  sharePublicly: false,
  shareToIntegrations: false,
})

const ChannelsRecord = Record(
  {
    id: '',
    createdBy: null,
    createdAt: 0,
    updatedAt: 0,
    lastActivityAt: 0,
    lastActivityBy: '',
    activityCount: 0,
    name: '',
    members: Map(),
    memberships: null,
    organizationId: '',
    type: channelTypes.PRIVATE,
    currentUserRole: 'none',
    activityAcknowledgement: null,
    defaultRole: '',
    orderByField: null,
    orderByDirection: null,
    permissions: ChannelsPermissions(),
    publiclySharedAt: null,
    publicShareToken: '',
    shareLink: '',
    notes: List(),
  },
  'channel'
)

export const isPrivate = channel =>
  channel && channel.type === channelTypes.PRIVATE
export const isPersonal = channel =>
  channel && channel.type === channelTypes.PERSONAL
export const isPublic = channel =>
  channel && channel.type === channelTypes.PUBLIC

export default ChannelsRecord
